import { React } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';

import LOGIN from '../../assets/imgs/login.png';
import LOGOUT from '../../assets/imgs/logout.png';
import USER from '../../assets/imgs/user.png';
import CART from '../../assets/imgs/cart.png';
import { reset } from '../../redux/userSlice';

const IconWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 10px;
`;

const Icon = styled.button`
	height: 30px;
	background-color: transparent;
	border: none;
	cursor: pointer;
`;

const IconData = { 
	'shoppingCart' : { label: 'shoppingCart', icon: CART, link: '/shopping-cart', non_auth_link: '/log-in' },
	'myPage' : { label: 'myPage', icon: USER, link: '/my', non_auth_link: '/log-in' },
	'logIn' : { label: 'logIn', icon: LOGIN, non_auth_link: '/log-in' },
	'logOut' : { label: 'logOut', icon: LOGOUT, link: '/log-out' },
};

function MenuIcon(props) {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const onClick = (link) => {
		navigate( link );
	};

	const onClickLogout = () => {
		alert("로그아웃 되었습니다.");
		navigate('/');

		setTimeout(() => {
			dispatch(reset());
		}, 100);
	};

	if ( props.data.label === 'logOut' ) {
		return (
			<Icon key={ props.data.label } onClick={ onClickLogout }>
				<img src={ props.data.icon } alt={ props.data.label } style={{ height: '100%' }}/>
			</Icon>
		);
	}

	return (
		<Icon key={ props.data.label } onClick={ () => onClick(props.isAuthenticated ? props.data.link : props.data.non_auth_link) }>
			<img src={ props.data.icon } alt={ props.data.label } style={{ height: '100%' }}/>
		</Icon>
	);
}

export default function MenuIconWrapper(props) {
	const isAuthenticated = useSelector((state) => state.user.isAuthenticated );

	return (
		<IconWrapper style={ props.style }>
			<MenuIcon data={ IconData.shoppingCart } isAuthenticated={ isAuthenticated } />
			<MenuIcon data={ IconData.myPage } isAuthenticated={ isAuthenticated } />
			{ 
				isAuthenticated ? <MenuIcon data={ IconData.logOut } isAuthenticated={ isAuthenticated } /> : <MenuIcon data={ IconData.logIn } isAuthenticated={ isAuthenticated } /> 
			}
		</IconWrapper>
	);
}